import DeployingFromGitLab from "../../../../src/courses/partials/responsible-development/deploying-from-version-control/gitlab.mdx";
import * as React from 'react';
export default {
  DeployingFromGitLab,
  React
};